import { helpers } from '../helpers.js';

var headerMenu = {
  options: {
    // global options
  },

  selectors: {
    header_menu: '.js-header-menu',
		menu_toggle_button: '.js-header-menu-toggle-button',
  },

  init: function () {
    const self = this;

    self.scrollEvent();
		self.mobileMenuToggle();
  },

	scrollEvent: function () {
		const self = this;

    jQuery(window).on('scroll', self.checkMenuPosition.bind(self));

    // Initial check
    self.checkMenuPosition();
	},

	mobileMenuToggle: function () {
		const self = this;

		const headerMenu = jQuery(self.selectors.header_menu);
		const menuToggleButton = jQuery(self.selectors.menu_toggle_button);

		menuToggleButton.on('click', function (e) {
			e.preventDefault();

			headerMenu.toggleClass('header--open');
		});
	},

  checkMenuPosition: function () {
    const self = this;

    // jQuery: Add 'fixed' class if window scroll is behind main > *:second-child
    const headerMenu = jQuery(self.selectors.header_menu);
    const secondChild = jQuery('main > *:nth-child(2)');

		if (!secondChild.length) {
			return;
		}

    const scrollTop = jQuery(window).scrollTop();
    const secondChildOffset = secondChild.offset() ? secondChild.offset().top : 0;

    if (scrollTop >= secondChildOffset) {
      headerMenu.addClass('header--fixed-prepare');
			setTimeout(function () {
				headerMenu.addClass('header--fixed');
			}, 10);
    } else {
      headerMenu.removeClass('header--fixed').removeClass('header--fixed-prepare');
    }
  }
}

// Export
export { headerMenu };